export { default as ProductLifecycleSlot } from './ProductLifecycleSlot';
